import { Box, CircularProgress } from '@mui/material';


const Loader = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={80} color="secondary"/>
    </Box>
  );
};

export default Loader;
